<template>
	<div class="chat-item" :class="active ? 'active' : ''" @contextmenu.prevent="showRightMenu($event)">
		<div class="chat-left">
			<!-- 群聊使用组合头像，私聊使用普通头像 -->
			<group-avatar v-if="chat.type == 'GROUP'" 
				:groupId="chat.targetId" 
				:groupName="chat.showName" 
				:defaultHeadImage="chat.headImage"
				:defaultHeadName="groupDefaultHeadName"
				:size="42">
			</group-avatar>
			<head-image v-else :url="chat.headImage" :name="chat.originalName || chat.showName" :size="42"
				:id="chat.type == 'PRIVATE' ? chat.targetId : 0" :isShowUserInfo="false"></head-image>
			<div v-show="chat.unreadCount > 0" class="unread-text"
				:class="{ 'unread-text-muted': chat.dnd }">{{ chat.unreadCount }}</div>
		</div>
		<div class="chat-right">
			<div class="chat-name">
				<div class="chat-name-text">
					<div>
						{{ chat.showName }}
						<el-tag v-if="chat.dnd" size="mini" type="info">免打扰</el-tag>
					</div>
					<el-tag v-if="chat.type == 'GROUP'" size="mini" >群</el-tag>
				</div>
				<div class="chat-time-text">{{ showTime }}</div>
			</div>
			<div class="chat-content">
				<div class="chat-at-text">{{ atText }}</div>
				<div class="chat-send-name" v-show="isShowSendName">{{ chat.sendNickName + ':&nbsp;' }}</div>
				<div class="chat-content-text" v-html="$emo.transform(chat.lastContent,'emoji-small')"></div>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
	</div>

</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RightMenu from '../common/RightMenu.vue';
import GroupAvatar from '../common/GroupAvatar.vue';
import useUserStore from '../../store/userStore';

export default {
	name: "chatItem",
	components: {
		HeadImage,
		RightMenu,
		GroupAvatar
	},
	data() {
		return {
			menuItems: [],
			userStore: useUserStore()
		}
	},
	props: {
		chat: {
			type: Object
		},
		active: {
			type: Boolean
		}
	},
	methods: {
		showRightMenu(e) {
			// 动态菜单：置顶/删除/免打扰 切换
			const items = [
				{ key: 'TOP', name: this.chat.pinned ? '取消置顶' : '置顶该聊天', icon: this.chat.pinned ? 'el-icon-bottom' : 'el-icon-top' },
				{ key: 'DND', name: this.chat.dnd ? '取消免打扰' : '开启免打扰', icon: 'el-icon-bell' },
				{ key: 'DELETE', name: '删除', icon: 'el-icon-delete' }
			];
			this.menuItems = items;
			// 显式传入坐标对象，避免事件对象在不同场景下导致偏移
			const pos = { x: e.clientX, y: e.clientY };
			this.$refs.rightMenu.open(pos, this.menuItems);
		},
		onSelectMenu(item) {
			if (item.key === 'DND') {
				this.chatStore.toggleChatDnd({ type: this.chat.type, targetId: this.chat.targetId });
				return;
			}
			this.$emit(item.key.toLowerCase(), this.chat);
		}
	},
	computed: {
		groupDefaultHeadName() {
			if (!this.chat || this.chat.type !== 'GROUP') {
				return '';
			}
			const userInfo = this.userStore.userInfo || {};
			if (!this.chat.ownerId || this.chat.ownerId == userInfo.id) {
				return userInfo.nickName || userInfo.userName || this.chat.showName;
			}
			return this.chat.ownerName || this.chat.ownerNickName || this.chat.showName;
		},
		isShowSendName() {
			if (!this.chat.sendNickName) {
				return false;
			}
			let size = this.chat.messages.length;
			if (size == 0) {
				return false;
			}
			// 只有群聊的普通消息需要显示名称
			let lastMsg = this.chat.messages[size - 1];
			return this.$msgType.isNormal(lastMsg.type)
		},
		showTime() {
			return this.$date.toTimeText(this.chat.lastSendTime, true)
		},
		atText() {
			if (this.chat.atMe) {
				return "[有人@我]"
			} else if (this.chat.atAll) {
				return "[@全体成员]"
			}
			return "";
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-item {
	height: 60px;
	display: flex;
	position: relative;
	padding: 8px 10px;
	margin: 2px 4px;
	align-items: center;
	background-color: transparent;
	border-radius: 10px;
	white-space: nowrap;
	cursor: pointer;
	transition: background-color 0.16s ease, transform 0.12s ease;

	&:hover {
		background-color: rgba(148, 163, 184, 0.15);
	}

	&.active {
			background-color: #d4def5; /* 与通讯录选中项一致的浅蓝背景 */

			.chat-right {
				.chat-name {
					.chat-name-text {
						color: #1a73e8;
					}
				}
			}
		}

	.chat-left {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;

		.unread-text {
			position: absolute;
			background-color: #f56c6c;
			right: -4px;
			top: -8px;
			color: white;
			border-radius: 30px;
			padding: 1px 5px;
			font-size: 10px;
			text-align: center;
			white-space: nowrap;
			border: 1px solid #f1e5e5;
		}

		.unread-text-muted {
			background-color: #909399;
			border-color: #e5e7eb;
		}
	}


	.chat-right {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding-left: 10px;
		text-align: left;
		overflow: hidden;

		.chat-name {
			display: flex;
			line-height: 20px;
			height: 20px;

			.chat-name-text {
				flex: 1;
				display: flex;
				align-items: center;
				font-size: var(--im-font-size);
				white-space: nowrap;
				overflow: hidden;

				.el-tag {
					min-width: 22px;
					text-align: center;
					border-radius: 10px;
					border: 0;
					height: 16px;
				}
			}

			.chat-time-text {
				font-size: var(--im-font-size-smaller);
				text-align: right;
				color: #9ca3af;
				white-space: nowrap;
				overflow: hidden;
				padding-left: 10px;
			}
		}

		.chat-content {
			display: flex;
			line-height: 22px;

			.chat-at-text {
				color: #f97373;
				font-size: var(--im-font-size-smaller);
			}

			.chat-send-name {
				font-size: var(--im-font-size-small);
				color: #e5e7eb;
			}
			
			.chat-content-text {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: var(--im-font-size-small);
				color: #9ca3af;
			}

		}
	}
}
</style>
